/* nc-rutyna-cart.js — "dokompletuj Rutynę" cart cross-sell.

   When the cart holds 1 or 2 of a campaign set's 3 products, this shows the
   missing ones with the set's name and description, so a started routine can
   be completed in one click. Renders into the Rebuy SmartCart drawer and into
   [data-nc-rutyna-slot] on the /cart page. Sets come from
   snippets/nc-rutyna-sets.liquid.

   FREEZE SAFETY — read before changing:
   This deliberately uses NO MutationObserver. Rebuy re-renders its drawer on
   every cart change, so observing the subtree we also write into is exactly
   the observe-and-mutate loop that froze the drawer before (see the history on
   nc-rebuy-cart-v1.js). Instead: a slow heartbeat re-inserts the node if Rebuy
   wiped it, working from already-cached data (no network on a beat), guarded
   against re-entrancy, and made idempotent by a content signature. */
(function () {
  'use strict';

  if (window.__ncRutynaLoaded) return;
  window.__ncRutynaLoaded = true;
  // Kill switches: the theme-wide one, plus a dedicated one for this widget.
  if (/[?&](natu_off|nc_rutyna_off)=1/.test(location.search)) return;

  var SETS = window.NC_RUTYNA_SETS;
  if (!SETS || !SETS.length) return;

  var HEARTBEAT_MS = 1200;
  var state = { match: null, items: null, sig: '' };
  var productCache = {};
  var BUSY = false;

  /* ---- helpers -------------------------------------------- */

  function money(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' zł';
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function firstAvailableVariant(product) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return null;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function loadProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        // Never cache a miss permanently — a transient failure must retry.
        if (!p) delete productCache[handle];
        return p;
      })
      .catch(function () { delete productCache[handle]; return null; });
    return productCache[handle];
  }

  /* ---- matching ------------------------------------------- */

  // Best = the set the shopper is furthest into. A complete set has nothing
  // left to sell; a set with nothing in the cart is not a routine they started.
  function matchSet(cart) {
    if (!cart || !cart.items || !cart.items.length) return null;
    var inCart = {};
    cart.items.forEach(function (item) { if (item.handle) inCart[item.handle] = true; });

    var best = null;
    SETS.forEach(function (set) {
      var have = [];
      var missing = [];
      (set.items || []).forEach(function (entry) {
        (inCart[entry.handle] ? have : missing).push(entry);
      });
      if (!have.length || !missing.length) return;
      if (!best || have.length > best.have.length) {
        best = { set: set, have: have, missing: missing };
      }
    });
    return best;
  }

  /* ---- markup --------------------------------------------- */

  function hintCopy(missingCount) {
    return missingCount === 1
      ? 'Masz już 2 z 3 produktów tego rytuału. Dodaj ostatni — w komplecie działają najlepiej.'
      : 'Masz już 1 z 3 produktów tego rytuału. Uzupełnij go, żeby zadziałał w pełni.';
  }

  function buildNode(match, items, sig) {
    var node = document.createElement('div');
    node.className = 'nc-rutyna';
    node.setAttribute('data-nc-rutyna', '');
    node.setAttribute('data-nc-rutyna-sig', sig);

    var rows = items.map(function (row) {
      return '' +
        '<li class="nc-rutyna__item">' +
          '<a class="nc-rutyna__thumb" href="' + esc(row.product.url) + '" tabindex="-1" aria-hidden="true">' +
            (row.product.featured_image
              ? '<img src="' + esc(sized(row.product.featured_image, 160)) + '" alt="" loading="lazy" width="56" height="56">'
              : '') +
          '</a>' +
          '<span class="nc-rutyna__info">' +
            '<a class="nc-rutyna__name" href="' + esc(row.product.url) + '">' + esc(row.product.title) + '</a>' +
            (row.def.note ? '<span class="nc-rutyna__note">' + esc(row.def.note) + '</span>' : '') +
          '</span>' +
          '<span class="nc-rutyna__buy">' +
            '<span class="nc-rutyna__price">' + esc(money(row.variant.price)) + '</span>' +
            '<button type="button" class="nc-rutyna__btn" data-nc-rutyna-add="' + esc(row.variant.id) + '">' +
              '<span data-nc-rutyna-label>Dodaj</span>' +
            '</button>' +
          '</span>' +
        '</li>';
    }).join('');

    node.innerHTML = '' +
      '<div class="nc-rutyna__head">' +
        '<span class="nc-rutyna__eyebrow">Skompletuj rytuał</span>' +
        '<h3 class="nc-rutyna__title">' + esc(match.set.title) + '</h3>' +
        (match.set.blurb ? '<p class="nc-rutyna__blurb">' + esc(match.set.blurb) + '</p>' : '') +
      '</div>' +
      '<p class="nc-rutyna__hint">' + esc(hintCopy(items.length)) + '</p>' +
      '<ul class="nc-rutyna__items">' + rows + '</ul>' +
      '<p class="nc-rutyna__error" data-nc-rutyna-error>Nie udało się dodać do koszyka. Spróbuj ponownie.</p>';

    return node;
  }

  /* ---- rendering ------------------------------------------ */

  // Every surface the widget can live on. The drawer anchor only exists while
  // Rebuy has rendered (it is consent-gated, so it legitimately may not).
  function hosts() {
    var out = [];
    document.querySelectorAll('[data-nc-rutyna-slot]').forEach(function (el) { out.push(el); });
    var drawerBody = document.querySelector('.rebuy-cart [data-rebuy-cart-anchor="body"]');
    if (drawerBody) out.push(drawerBody);
    return out;
  }

  function render() {
    if (BUSY) return;
    BUSY = true;
    try {
      hosts().forEach(function (host) {
        var existing = host.querySelector('[data-nc-rutyna]');
        if (!state.match || !state.items || !state.items.length) {
          if (existing) existing.remove();
          return;
        }
        // Idempotent: an unchanged node is left exactly as it is, so a beat
        // never rewrites DOM Rebuy is also touching.
        if (existing && existing.getAttribute('data-nc-rutyna-sig') === state.sig) return;
        var node = buildNode(state.match, state.items, state.sig);
        if (existing) existing.replaceWith(node);
        else host.appendChild(node);
      });
    } catch (e) {
      /* never let a render break the cart */
    } finally {
      BUSY = false;
    }
  }

  function refresh() {
    return fetchCart().then(function (cart) {
      var match = matchSet(cart);
      if (!match) {
        state.match = null;
        state.items = null;
        state.sig = '';
        render();
        return;
      }
      return Promise.all(match.missing.map(function (entry) {
        return loadProduct(entry.handle);
      })).then(function (products) {
        var items = [];
        match.missing.forEach(function (entry, i) {
          var variant = firstAvailableVariant(products[i]);
          // Skip anything sold out or unpublished — never offer what can't be bought.
          if (variant) items.push({ def: entry, product: products[i], variant: variant });
        });
        state.match = items.length ? match : null;
        state.items = items.length ? items : null;
        state.sig = items.length
          ? match.set.id + '|' + items.map(function (r) { return r.variant.id; }).join(',')
          : '';
        render();
      });
    });
  }

  /* ---- add to cart ---------------------------------------- */

  function nudgeRebuy() {
    try {
      var R = window.Rebuy || window.rebuy;
      if (R && R.Cart && typeof R.Cart.updateItem === 'function') R.Cart.updateItem();
    } catch (e) { /* drawer re-reads on its next cart change */ }
  }

  // Delegated on document, bound once: survives every Rebuy re-render without
  // needing to observe or re-bind anything.
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-nc-rutyna-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var variantId = parseInt(btn.getAttribute('data-nc-rutyna-add'), 10);
    if (!variantId) return;
    var root = btn.closest('[data-nc-rutyna]');
    var errorEl = root && root.querySelector('[data-nc-rutyna-error]');
    var label = btn.querySelector('[data-nc-rutyna-label]');
    var original = label ? label.textContent : '';

    btn.disabled = true;
    btn.classList.add('is-loading');
    if (label) label.textContent = 'Dodaję…';
    if (errorEl) errorEl.classList.remove('is-visible');

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        if (label) label.textContent = 'Dodano ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        nudgeRebuy();
        // Re-read the cart: completing the set retires the widget on its own.
        return refresh();
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (label) label.textContent = original;
        if (errorEl) errorEl.classList.add('is-visible');
      });
  });

  /* ---- lifecycle ------------------------------------------ */

  var refreshTimer;
  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 250);
  }

  ['rebuy:cart.change', 'rebuy:cart.enriched', 'rebuy:cart.add', 'rebuy:smartcart.ready',
   'cart:updated', 'cart:refresh'].forEach(function (evt) {
    document.addEventListener(evt, scheduleRefresh);
  });
  window.addEventListener('cart:refresh', scheduleRefresh);

  function init() {
    refresh();
    // Re-insert only; works from cache, so a beat costs a few DOM reads.
    window.setInterval(render, HEARTBEAT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
